import classNames from 'classnames';
import { Foundation } from 'src/.generated/Foundation.EnterpriseWeb.model';
import { Button } from '../Button';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';

export type SingleButtonProps = Foundation.EnterpriseWeb.Enterprise.FieldSets.Cta1 & {
  classes?: {
    wrapper?: string;
    cta1Classes?: string;
  };
  suppressLinkText?: boolean;
};

const SingleButton = ({ fields, classes, suppressLinkText }: SingleButtonProps): JSX.Element => {
  if (!fields?.cta1Link) {
    return <></>;
  }
  return (
    <div
      className={classNames(
        classes?.wrapper,
        'flex items-start md:mb-s md:flex-row md:items-center'
      )}
    >
      <Button
        field={fields?.cta1Link}
        variant={fields?.cta1Style}
        icon={fields?.cta1Icon}
        modalId={
          (
            fields?.cta1Modal as unknown as Feature.EnterpriseWeb.Enterprise.Components.Modal.GenericModal.GenericModal
          )?.fields?.modalId?.value
        }
        modalLinkText={fields?.cta1ModalLinkText}
        classes={classNames(classes?.cta1Classes)}
        ariaLabel={fields.cta1AriaLabel}
        suppressLinkText={suppressLinkText}
      />
    </div>
  );
};

export default SingleButton;
